import { createSlice } from '@reduxjs/toolkit';
import { createAppAsyncThunk } from '../../createAppAsyncThunk';
import { API_POST } from '../../../services';
import { EcomOrderDetails } from '../../../models/EcomOrderDetailsModel';
import type { RootState } from '../../store';
import { env } from '../../../env';
import { ENDPOINTS } from '../../../constants/endPoints';
import { RADRequest } from '../../../models/common/RADRequest';

interface EcomOrderDetailsState {
  data: EcomOrderDetails | null;
  isLoading: boolean;
}

const initialState: EcomOrderDetailsState = {
  data: null,
  isLoading: false,
};

// Async thunk to fetch Ecom Order Details data
export const fetchEcomOrderDetails = createAppAsyncThunk(
  'ecommerce/fetchEcomOrderDetails',
  async (payload: RADRequest) => {
    const requestBody = {
      StoreNumber: payload.storeNumber,
      IsMultiStoreMode: payload.isMultiStoreMode,
    };

    const response = await API_POST(
      `${env.RAD_APP_API_URL}${ENDPOINTS.GET_ECOM_ORDER_DETAILS}`,
      requestBody,
    );
    return response as EcomOrderDetails;
  },
);

// Ecom Order Details slice
const ecomOrderDetailsSlice = createSlice({
  name: 'ecomOrderDetails',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(fetchEcomOrderDetails.pending, state => {
        state.isLoading = true;
      })
      .addCase(fetchEcomOrderDetails.fulfilled, (state, action) => {
        state.data = action.payload;
        state.isLoading = false;
      })
      .addCase(fetchEcomOrderDetails.rejected, state => {
        state.data = null;
        state.isLoading = false;
      });
  },
});

// Selectors
export const selectEcomOrderDetails = (state: RootState) => state.ecomOrderDetails.data;
export const selectEcomOrderDetailsLoading = (state: RootState) => state.ecomOrderDetails.isLoading;

export default ecomOrderDetailsSlice.reducer;
